import type { User } from "@/types/user";
import { createContext, useState, type ReactNode } from "react";

export const UserContext = createContext({
  user: null as User | null,
  setUser: (user: User | null) => {},
  selectedProgram: "chp" as string,
  setSelectedProgram: (program: string) => {},
});

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [selectedProgram, setSelectedProgram] = useState<string>("chp");

  return (
    <UserContext.Provider
      value={{ user, setUser, selectedProgram, setSelectedProgram }}
    >
      {children}
    </UserContext.Provider>
  );
};
